import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceTabs from './components/ServiceTabs';
import ServiceDetails from './components/ServiceDetails';

const ServicesPage = () => {
  const [activeTab, setActiveTab] = useState('ocean');
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://trackverse.com';

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://track-verse.com';
    document.title = 'Services Logistiques — Fret Maritime, Aérien, Routier & Ferroviaire | TrackVerse';
    document.documentElement.lang = 'fr';

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('description', 'TrackVerse propose des services logistiques complets : fret maritime FCL/LCL, fret aérien express, transport routier et logistique ferroviaire avec suivi temps réel dans 50+ pays depuis Ajaccio.');
    setMeta('keywords', 'fret maritime, fret aérien, transport routier, logistique ferroviaire, services expédition, TrackVerse services');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); (canonical as HTMLLinkElement).rel = 'canonical'; document.head.appendChild(canonical); }
    (canonical as HTMLLinkElement).href = `${siteUrl}/services`;

    setMeta('og:title', 'Services Logistiques TrackVerse — Fret Maritime, Aérien & Routier', true);
    setMeta('og:description', 'Services complets de logistique internationale : fret maritime, aérien, routier et ferroviaire avec suivi temps réel dans 50+ pays.', true);
    setMeta('og:url', `${siteUrl}/services`, true);
    setMeta('og:type', 'website', true);
    setMeta('og:image', `${siteUrl}/og-image.jpg`, true);
    setMeta('twitter:title', 'Services Logistiques TrackVerse — Fret Maritime, Aérien & Routier');
    setMeta('twitter:description', 'Fret maritime, aérien, routier et ferroviaire avec suivi temps réel dans 50+ pays.');
    setMeta('twitter:image', `${siteUrl}/og-image.jpg`);

    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Services Logistiques TrackVerse",
      "description": "Services complets de logistique et fret international",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
          { "@type": "ListItem", "position": 2, "name": "Services", "item": `${siteUrl}/services` }
        ]
      },
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "item": { "@type": "Service", "name": "Fret Maritime", "description": "Transport de conteneurs FCL et LCL avec couverture mondiale des ports", "provider": { "@type": "Organization", "name": "TrackVerse" } } },
        { "@type": "ListItem", "position": 2, "item": { "@type": "Service", "name": "Fret Aérien", "description": "Fret aérien express et standard avec manutention prioritaire", "provider": { "@type": "Organization", "name": "TrackVerse" } } },
        { "@type": "ListItem", "position": 3, "item": { "@type": "Service", "name": "Transport Routier", "description": "Solutions de transport routier flexibles pour livraisons régionales et transfrontalières", "provider": { "@type": "Organization", "name": "TrackVerse" } } },
        { "@type": "ListItem", "position": 4, "item": { "@type": "Service", "name": "Logistique Ferroviaire", "description": "Fret ferroviaire écologique pour les routes Europe-Asie", "provider": { "@type": "Organization", "name": "TrackVerse" } } }
      ]
    };

    let script = document.querySelector('script[data-schema="services"]');
    if (!script) { script = document.createElement('script'); script.setAttribute('type', 'application/ld+json'); script.setAttribute('data-schema', 'services'); document.head.appendChild(script); }
    script.textContent = JSON.stringify(serviceSchema);

    return () => { const s = document.querySelector('script[data-schema="services"]'); if (s) s.remove(); };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <ServiceHero />
      <ServiceTabs activeTab={activeTab} onTabChange={setActiveTab} />
      <ServiceDetails activeTab={activeTab} />
      <Footer />
    </div>
  );
};

export default ServicesPage;
